import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import SalaryDetail from "./components/SalaryDetail";
import PayrollV2Detail from "./components/PayrollV2Detail";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/salary/v2/:token" element={<PayrollV2Detail />} />
          <Route path="/salary/:id" element={<SalaryDetail />} />
          {/* Add other routes here if needed */}
          <Route
            path="/"
            element={
              <div>
                <h1>Chào mừng đến với hệ thống bảng lương</h1>
                <p>
                  Vui lòng sử dụng liên kết trong email để xem chi tiết bảng lương.
                </p>
              </div>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
